import { baseRoutes } from "routes"

export const NAVIGATION_LINKS = [
  { id: 1, title: "Our Offering", to: baseRoutes.ourOffering() },
  { id: 2, title: "Cove 101", to: baseRoutes.cove101() },
  { id: 3, title: "Blog", to: baseRoutes.blog() },
  { id: 4, title: "Reviews", to: baseRoutes.reviews() }
]
